var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.2104C2 9.61655 2.27618 9.05489 2.75061 8.68392L10.7506 2.42837C11.481 1.85721 12.519 1.85721 13.2494 2.42837L21.2494 8.68392C21.7238 9.05489 22 9.61655 22 10.2104V20.0451C22 21.1248 21.1046 22 20 22H15V17.0903C15 15.4708 13.6569 14.158 12 14.158C10.3431 14.158 9 15.4708 9 17.0903V22H4C2.89543 22 2 21.1248 2 20.0451V10.2104ZM12.75 5.36113C12.75 4.95627 12.4142 4.62806 12 4.62806C11.5858 4.62806 11.25 4.95627 11.25 5.36113V7.56035H9C8.58579 7.56035 8.25 7.88856 8.25 8.29342C8.25 8.69829 8.58579 9.02649 9 9.02649H11.25V11.2257C11.25 11.6306 11.5858 11.9588 12 11.9588C12.4142 11.9588 12.75 11.6306 12.75 11.2257V9.02649H15C15.4142 9.02649 15.75 8.69829 15.75 8.29342C15.75 7.88856 15.4142 7.56035 15 7.56035H12.75V5.36113Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.da9a577bbd47038861b75f79ac1d3385.svg";
export { ForwardRef as ReactComponent };